export const MY_QUOTES = "my-quotes";
